{
  "{{ commaSeparatedUsers }} and {{ moreCount }} more": "{{ commaSeparatedUsers }} und {{moreCount}} mehr",
  "{{ commaSeparatedUsers }}, and {{ lastUser }}": "{{ commaSeparatedUsers }} und {{ lastUser }}",
  "{{ count }} files_one": "{{ count }} Datei",
  "{{ count }} files_other": "{{ count }} Dateien",
  "{{ count }} people are typing_one": "{{ count }} Person tippt",
  "{{ count }} people are typing_many": "{{ count }} Personen tippen",
  "{{ count }} people are typing_other": "{{ count }} Personen tippen",
  "{{ count }} photos_one": "{{ count }} Foto",
  "{{ count }} photos_other": "{{ count }} Fotos",
  "{{ count }} reactions_one": "{{ count }} Reaktion",
  "{{ count }} reactions_other": "{{ count }} Reaktionen",
  "{{ count }} videos_one": "{{ count }} Video",
  "{{ count }} videos_other": "{{ count }} Videos",
  "{{ firstUser }} and {{ secondUser }}": "{{ firstUser }} und {{ secondUser }}",
  "{{ imageCount }} more": "{{ imageCount }} mehr",
  "{{ memberCount }} members": "{{ memberCount }} Mitglieder",
  "{{ typing }} are typing": "{{ typing }} tippen",
  "{{ typing }} is typing": "{{ typing }} tippt",
  "{{ user }} has been muted": "{{ user }} wurde stummgeschaltet",
  "{{ user }} has been unmuted": "Die Stummschaltung von {{ user }} wurde aufgehoben",
  "{{ user }} is typing...": "{{ user }} tippt...",
  "{{ users }} and {{ user }} are typing...": "{{ users }} und {{ user }} tippen...",
  "{{ users }} and more are typing...": "{{ users }} und mehr tippen...",
  "{{ watcherCount }} online": "{{ watcherCount }} online",
  "{{count}} new messages_one": "{{count}} neue Nachricht",
  "{{count}} new messages_other": "{{count}} neue Nachrichten",
  "{{count}} unread_one": "{{count}} ungelesen",
  "{{count}} unread_other": "{{count}} ungelesen",
  "{{count}} votes_one": "{{count}} Stimme",
  "{{count}} votes_other": "{{count}} Stimmen",
  "+{{ imageCount }}": "+{{ imageCount }}",
  "+{{count}} more options_one": "+{{count}} weitere Option",
  "+{{count}} more options_other": "+{{count}} weitere Optionen",
  "🏙 Attachment...": "🏙 Anhang...",
  "📊 {{createdBy}} created: {{ pollName}}": "📊 {{createdBy}} hat erstellt: {{ pollName}}",
  "📊 {{votedBy}} voted: {{pollOptionText}}": "📊 {{votedBy}} hat abgestimmt: {{pollOptionText}}",
  "📍Shared location": "📍Geteilter Standort",
  "Add a comment": "Einen Kommentar hinzufügen",
  "Add a comment to your poll answer": "Füge einen Kommentar zu deiner Umfrageantwort hinzu",
  "Add an option": "Eine Option hinzufügen",
  "Add reaction": "Reaktion hinzufügen",
  "All results loaded": "Alle Ergebnisse geladen",
  "Allow access to camera": "Zugriff auf Kamera erlauben",
  "Allow access to microphone": "Zugriff auf Mikrofon erlauben",
  "Allow comments": "Kommentare erlauben",
  "Allow option suggestion": "Optionsvorschläge erlauben",
  "Allow others to add comments": "Anderen das Hinzufügen von Kommentaren erlauben",
  "Also send as a direct message": "Auch als Direktnachricht senden",
  "Also send in channel": "Auch im Kanal senden",
  "Also sent in channel": "Auch im Kanal gesendet",
  "An error has occurred during recording": "Ein Fehler ist während der Aufnahme aufgetreten",
  "An error has occurred during the recording processing": "Ein Fehler ist während der Aufnahmeverarbeitung aufgetreten",
  "Anonymous": "Anonym",
  "Anonymous poll": "Anonyme Umfrage",
  "Archive": "Archivieren",
  "Are you sure you want to delete this message?": "Sind Sie sicher, dass Sie diese Nachricht löschen möchten?",
  "aria/Attachment": "Anhang",
  "aria/Attachment Actions": "Anhangaktionen",
  "aria/Audio position {{ elapsed }} of {{ duration }}": "Audioposition {{ elapsed }} von {{ duration }}",
  "aria/Audio position {{ progress }} percent": "Audioposition {{ progress }} Prozent",
  "aria/Block User": "Benutzer blockieren",
  "aria/Bookmark Message": "Nachricht für später speichern",
  "aria/Cancel recording": "Aufnahme abbrechen",
  "aria/Cancel Reply": "Antwort abbrechen",
  "aria/Cancel upload": "Upload abbrechen",
  "aria/Channel Actions": "Kanalaktionen",
  "aria/Channel list": "Kanalliste",
  "aria/Channel search results": "Kanalsuchergebnisse",
  "aria/Chat view tabs": "Chat-Ansicht Tabs",
  "aria/Clear search": "Suche leeren",
  "aria/Close callout dialog": "Hinweisdialog schließen",
  "aria/Close thread": "Thread schließen",
  "aria/Collapse sidebar": "Seitenleiste einklappen",
  "aria/Command Suggestions": "Befehlsvorschläge",
  "aria/Complete recording": "Aufnahme abschließen",
  "aria/Copy Message Text": "Nachrichtentext kopieren",
  "aria/Decrease value": "Wert verringern",
  "aria/Delete Message": "Nachricht löschen",
  "aria/Dismiss notification": "Benachrichtigung schließen",
  "aria/Download attachment": "Anhang herunterladen",
  "aria/Edit Message": "Nachricht bearbeiten",
  "aria/Emoji picker": "Emoji-Auswahl",
  "aria/Emoji Suggestions": "Emoji-Vorschläge",
  "aria/Exit search": "Suche verlassen",
  "aria/Expand sidebar": "Seitenleiste einblenden",
  "aria/File input": "Dateieingabe",
  "aria/File upload": "Datei hochladen",
  "aria/Flag Message": "Nachricht melden",
  "aria/Image failed to load": "Bild konnte nicht geladen werden",
  "aria/Image input": "Bildeingabe",
  "aria/Increase value": "Wert erhöhen",
  "aria/Jump to latest message": "Zur neuesten Nachricht springen",
  "aria/Jump to quoted message": "Zur zitierten Nachricht springen",
  "aria/Load More Channels": "Mehr Kanäle laden",
  "aria/Mark Message Unread": "Als ungelesen markieren",
  "aria/Mark messages as read": "Nachrichten als gelesen markieren",
  "aria/Menu": "Menü",
  "aria/Message Actions": "Nachrichtenaktionen",
  "aria/Message from {{ user }},": "Nachricht von {{ user }},",
  "aria/Message Options": "Nachrichtenoptionen",
  "aria/Message,": "Nachricht,",
  "aria/Mute User": "Benutzer stummschalten",
  "aria/Notifications": "Benachrichtigungen",
  "aria/Open Attachment Selector": "Anhang-Auswahl öffnen",
  "aria/Open Channel Actions Menu": "Kanalaktionsmenü öffnen",
  "aria/Open Menu": "Menü öffnen",
  "aria/Open Message Actions Menu": "Nachrichtenaktionsmenü öffnen",
  "aria/Open Reaction Selector": "Reaktionsauswahl öffnen",
  "aria/Open Thread": "Thread öffnen",
  "aria/Pause": "Pausieren",
  "aria/Pause recording": "Aufnahme pausieren",
  "aria/Percent complete": "{{percent}} Prozent abgeschlossen",
  "aria/Pin Message": "Nachricht anheften",
  "aria/Play": "Abspielen",
  "aria/Quote Message": "Nachricht zitieren",
  "aria/Reaction list": "Reaktionsliste",
  "aria/Remind Me Message": "Erinnern",
  "aria/Remind Me Options": "Erinnerungsoptionen",
  "aria/Remove attachment": "Anhang entfernen",
  "aria/Remove location attachment": "Standortanhang entfernen",
  "aria/Remove option": "Option entfernen",
  "aria/Remove Reminder": "Erinnerung entfernen",
  "aria/Remove Save For Later": "„Später ansehen“ entfernen",
  "aria/Resend Message": "Nachricht erneut senden",
  "aria/Resume recording": "Aufnahme fortsetzen",
  "aria/Retry upload": "Upload erneut versuchen",
  "aria/Review bounced message": "Zurückgewiesene Nachricht prüfen",
  "aria/Search results": "Suchergebnisse",
  "aria/Search results header filter button for: {{ source }}": "Filterbutton in der Kopfzeile der Suchergebnisse für: {{ source }}",
  "aria/Seek audio position": "Audioposition suchen",
  "aria/Select Channel: {{ channelName }}": "Kanal auswählen: {{ channelName }}",
  "aria/Select Reaction: {{ reactionName }}": "Reaktion auswählen: {{ reactionName }}",
  "aria/Select User Channel: {{ name }}": "Benutzerkanal auswählen: {{ name }}",
  "aria/Send": "Senden",
  "aria/Show preview": "Vorschau anzeigen",
  "aria/Start recording audio": "Audioaufnahme starten",
  "aria/Stop AI Generation": "KI-Generierung stoppen",
  "aria/Suggestions": "Vorschläge",
  "aria/Thread list": "Thread-Liste",
  "aria/Unblock User": "Benutzer entsperren",
  "aria/Unmute User": "Stummschaltung aufheben",
  "aria/Unpin Message": "Anheftung aufheben",
  "aria/User Suggestions": "Benutzervorschläge",
  "Ask a question": "Eine Frage stellen",
  "Attach": "Anhängen",
  "Attach files": "Dateien anhängen",
  "Attachment": "Anhang",
  "Attachment upload blocked due to {{reason}}": "Anhang-Upload blockiert wegen {{reason}}",
  "Attachment upload failed due to {{reason}}": "Anhang-Upload fehlgeschlagen wegen {{reason}}",
  "Back": "Back",
  "ban-command-args": "[@Benutzername] [Text]",
  "ban-command-description": "Einen Benutzer verbannen",
  "Block User": "Benutzer blockieren",
  "Cancel": "Abbrechen",
  "Cannot seek in the recording": "In der Aufnahme kann nicht gesucht werden",
  "Channel archived": "Kanal archiviert",
  "Channel Missing": "Kanal fehlt",
  "Channel muted": "Kanal stummgeschaltet",
  "Channel pinned": "Kanal angeheftet",
  "Channel unarchived": "Kanal dearchiviert",
  "Channel unmuted": "Stummschaltung des Kanals aufgehoben",
  "Channel unpinned": "Kanal nicht mehr angeheftet",
  "Channels": "Kanäle",
  "Chats": "Chats",
  "Choose between 2 to 10 options": "Wähle zwischen 2 und 10 Optionen",
  "Close": "Schließen",
  "Close dialog": "Dialog schließen",
  "Close emoji picker": "Emoji-Auswahl schließen",
  "Close prompt: {{ title }}": "Eingabeaufforderung schließen: {{ title }}",
  "Command not available while editing": "Befehl beim Bearbeiten nicht verfügbar",
  "Command not available while replying": "Befehl beim Antworten nicht verfügbar",
  "Commands": "Befehle",
  "Commands matching": "Übereinstimmende Befehle",
  "Connection failure, reconnecting now...": "Verbindungsfehler, Wiederherstellung der Verbindung...",
  "Copy Message": "Nachricht kopieren",
  "Create": "Erstellen",
  "Create a question, add options, and configure poll settings": "Erstelle eine Frage, füge Optionen hinzu und konfiguriere die Umfrageeinstellungen",
  "Create poll": "Umfrage erstellen",
  "Current location": "Aktueller Standort",
  "Delete": "Löschen",
  "Delete for me": "Für mich löschen",
  "Delete message": "Nachricht löschen",
  "Delivered": "Zugestellt",
  "Direct message": "Direktnachricht",
  "Do you want to end this poll now? Nobody will be able to vote in this poll anymore.": "Möchten Sie diese Umfrage jetzt beenden? Niemand wird mehr in dieser Umfrage abstimmen können.",
  "Download All": "Alle herunterladen",
  "Download Attachment": "Anhang herunterladen",
  "Download attachment {{ name }}": "Anhang {{ name }} herunterladen",
  "Drag your files here": "Ziehen Sie Ihre Dateien hierher",
  "Drag your files here to add to your post": "Ziehen Sie Ihre Dateien hierher, um sie Ihrem Beitrag hinzuzufügen",
  "Due {{ timeLeft }}": "Fällig {{ timeLeft }}",
  "Due since {{ dueSince }}": "Fällig seit {{ dueSince }}",
  "duration/Message reminder": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Remind Me": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Share Location": "{{ milliseconds | durationFormatter }}",
  "Edit Message": "Nachricht bearbeiten",
  "Edit message request failed": "Anfrage zum Bearbeiten der Nachricht fehlgeschlagen",
  "Edited": "Bearbeitet",
  "Emoji matching": "Passende Emojis",
  "Empty message...": "Leere Nachricht...",
  "End": "Beenden",
  "End poll": "Umfrage beenden",
  "End this poll?": "Umfrage beenden?",
  "End vote": "Abstimmung beenden",
  "Enforce unique vote is enabled": "Eindeutige Abstimmung ist aktiviert",
  "Error": "Fehler",
  "Error adding flag": "Fehler beim Hinzufügen des Flags",
  "Error connecting to chat, refresh the page to try again.": "Verbindungsfehler zum Chat, aktualisieren Sie die Seite, um es erneut zu versuchen.",
  "Error deleting message": "Fehler beim Löschen der Nachricht",
  "Error fetching reactions": "Fehler beim Laden von Reaktionen",
  "Error marking message unread. Cannot mark unread messages older than the newest 100 channel messages.": "Fehler beim Markieren der Nachricht als ungelesen. Kann keine älteren ungelesenen Nachrichten markieren als die neuesten 100 Kanalnachrichten.",
  "Error muting a user ...": "Fehler beim Stummschalten eines Nutzers.",
  "Error pinning message": "Fehler beim Pinnen der Nachricht",
  "Error removing message pin": "Fehler beim Entfernen der gepinnten Nachricht",
  "Error reproducing the recording": "Fehler bei der Wiedergabe der Aufnahme",
  "Error starting recording": "Fehler beim Starten der Aufnahme",
  "Error unmuting a user ...": "Fehler beim Aufheben der Stummschaltung eines Nutzers ...",
  "Error uploading attachment": "Fehler beim Hochladen des Anhangs",
  "Error uploading file": "Fehler beim Hochladen der Datei",
  "Error uploading image": "Fehler beim Hochladen des Bildes",
  "Error: {{ errorMessage }}": "Fehler: {{ errorMessage }}",
  "Exit command {{ command }}": "Befehl beenden {{ command }}",
  "Failed to block user": "Benutzer konnte nicht blockiert werden",
  "Failed to create the poll": "Fehler beim Erstellen der Umfrage",
  "Failed to create the poll due to {{reason}}": "Die Umfrage konnte aufgrund von {{reason}} nicht erstellt werden",
  "Failed to delete the message": "Nachricht konnte nicht gelöscht werden",
  "Failed to end the poll": "Umfrage konnte nicht beendet werden",
  "Failed to end the poll due to {{reason}}": "Umfrage konnte aufgrund von {{reason}} nicht beendet werden",
  "Failed to jump to the first unread message": "Fehler beim Springen zur ersten ungelesenen Nachricht",
  "Failed to leave channel": "Kanal konnte nicht verlassen werden",
  "Failed to load channels": "Kanäle konnten nicht geladen werden",
  "Failed to load more channels": "Weitere Kanäle konnten nicht geladen werden",
  "Failed to mark channel as read": "Fehler beim Markieren des Kanals als gelesen",
  "Failed to play the recording": "Wiedergabe der Aufnahme fehlgeschlagen",
  "Failed to retrieve location": "Standort konnte nicht abgerufen werden",
  "Failed to share location": "Standort konnte nicht geteilt werden",
  "Failed to update channel archive status": "Archivierungsstatus des Kanals konnte nicht aktualisiert werden",
  "Failed to update channel mute status": "Stummschaltungsstatus des Kanals konnte nicht aktualisiert werden",
  "Failed to update channel pinned status": "Anheftstatus des Kanals konnte nicht aktualisiert werden",
  "File": "Datei",
  "File is required for upload attachment": "Datei ist für den Anhang-Upload erforderlich",
  "File is too large: {{ size }}, maximum upload size is {{ limit }}": "Datei ist zu groß: {{ size }}, maximale Upload-Größe beträgt {{ limit }}",
  "File too large": "Datei ist zu groß",
  "fileCount_one": "1 datei",
  "fileCount_other": "{{ count }} dateien",
  "Flag": "Melden",
  "Generating...": "Generieren...",
  "giphy-command-args": "[Text]",
  "giphy-command-description": "Poste ein zufälliges Gif in den Kanal",
  "Hide who voted": "Verbergen, wer abgestimmt hat",
  "Image": "Bild",
  "imageCount_one": "Bild",
  "imageCount_other": "{{ count }} bilder",
  "Instant commands": "Instant commands",
  "language/af": "Afrikaans",
  "language/am": "Amharisch",
  "language/ar": "Arabisch",
  "language/az": "Aserbaidschanisch",
  "language/bg": "Bulgarisch",
  "language/bn": "Bengalisch",
  "language/bs": "Bosnisch",
  "language/cs": "Tschechisch",
  "language/da": "Dänisch",
  "language/de": "Deutsch",
  "language/el": "Griechisch",
  "language/en": "Englisch",
  "language/es": "Spanisch",
  "language/es-MX": "Spanisch (Mexiko)",
  "language/et": "Estnisch",
  "language/fa": "Persisch",
  "language/fa-AF": "Dari",
  "language/fi": "Finnisch",
  "language/fr": "Französisch",
  "language/fr-CA": "Französisch (Kanada)",
  "language/ha": "Hausa",
  "language/he": "Hebräisch",
  "language/hi": "Hindi",
  "language/hr": "Kroatisch",
  "language/ht": "Haitianisches Kreolisch",
  "language/hu": "Ungarisch",
  "language/id": "Indonesisch",
  "language/it": "Italienisch",
  "language/ja": "Japanisch",
  "language/ka": "Georgisch",
  "language/ko": "Koreanisch",
  "language/lt": "Litauisch",
  "language/lv": "Lettisch",
  "language/ms": "Malaiisch",
  "language/nl": "Niederländisch",
  "language/no": "Norwegisch",
  "language/pl": "Polnisch",
  "language/ps": "Paschtu",
  "language/pt": "Portugiesisch",
  "language/ro": "Rumänisch",
  "language/ru": "Russisch",
  "language/sk": "Slowakisch",
  "language/sl": "Slowenisch",
  "language/so": "Somali",
  "language/sq": "Albanisch",
  "language/sr": "Serbisch",
  "language/sv": "Schwedisch",
  "language/sw": "Swahili",
  "language/ta": "Tamil",
  "language/th": "Thailändisch",
  "language/tl": "Tagalog",
  "language/tr": "Türkisch",
  "language/uk": "Ukrainisch",
  "language/ur": "Urdu",
  "language/vi": "Vietnamesisch",
  "language/zh": "Chinesisch (Vereinfacht)",
  "language/zh-TW": "Chinesisch (Traditionell)",
  "Leave Channel": "Kanal verlassen",
  "Left channel": "Kanal verlassen",
  "Let others add options": "Andere Optionen hinzufügen lassen",
  "Limit votes per person": "Stimmen pro Person begrenzen",
  "Link": "Link",
  "linkCount_one": "Link",
  "linkCount_other": "{{ count }} links",
  "live": "live",
  "Live for {{duration}}": "Live für {{duration}}",
  "Live location": "Live-Standort",
  "Live until {{ timestamp }}": "Live bis {{ timestamp }}",
  "Load more": "Mehr laden",
  "Local upload attachment missing local id": "Lokaler Upload-Anhang hat keine lokale ID",
  "Location": "Standort",
  "Location sharing ended": "Standortfreigabe beendet",
  "Location: {{ coordinates }}": "Standort: {{ coordinates }}",
  "Mark as unread": "Als ungelesen markieren",
  "Maximum number of votes (from 2 to 10)": "Maximale Anzahl der Stimmen (von 2 bis 10)",
  "Maximum votes per person": "Maximale Stimmen pro Person",
  "Menu": "Menü",
  "Message deleted": "Nachricht gelöscht",
  "Message failed to send": "Nachricht konnte nicht gesendet werden",
  "Message has been successfully flagged": "Nachricht wurde erfolgreich gemeldet",
  "Message marked as unread": "Nachricht als ungelesen markiert",
  "Message pinned": "Nachricht angeheftet",
  "Message unpinned": "Nachricht nicht mehr angeheftet",
  "Message was blocked by moderation policies": "Nachricht wurde durch moderationsrichtlinien blockiert",
  "Messages have been marked unread.": "Nachrichten wurden als ungelesen markiert.",
  "Missing permissions to upload the attachment": "Fehlende Berechtigungen zum Hochladen des Anhangs",
  "Multiple votes": "Mehrfachstimmen",
  "Mute": "Stummschalten",
  "mute-command-args": "[@Benutzername]",
  "mute-command-description": "Stummschalten eines Benutzers",
  "network error": "Netzwerkfehler",
  "New": "Neu",
  "New message from {{user}}": "Neue Nachricht von {{user}}",
  "New Messages!": "Neue Nachrichten!",
  "Next image": "Nächstes Bild",
  "No chats here yet…": "Noch keine Chats hier...",
  "No conversations yet": "Noch keine Unterhaltungen",
  "No items exist": "Keine Elemente vorhanden",
  "No results found": "Keine Ergebnisse gefunden",
  "Nobody will be able to vote in this poll anymore.": "Niemand kann mehr in dieser Umfrage abstimmen.",
  "Nothing yet...": "Noch nichts...",
  "Offline": "Offline",
  "Ok": "OK",
  "Online": "Online",
  "Only numbers are allowed": "Nur Zahlen sind erlaubt",
  "Only visible to you": "Nur für dich sichtbar",
  "Open emoji picker": "Emoji-Auswahl öffnen",
  "Open gallery at image {{ index }}": "Galerie bei Bild {{ index }} öffnen",
  "Open image in gallery": "Bild in Galerie öffnen",
  "Open location in a map": "Standort in einer Karte öffnen",
  "Option already exists": "Option existiert bereits",
  "Option is empty": "Option ist leer",
  "Options": "Optionen",
  "Original": "Original",
  "People matching": "Passende Personen",
  "Photo": "Foto",
  "Pin": "Anheften",
  "Pinned by {{ name }}": "Angeheftet von {{ name }}",
  "Pinned by You": "Von Ihnen angeheftet",
  "placeholder/PollComment": "Ihr Kommentar",
  "placeholder/PollOptionSuggestion": "Neue Option eingeben",
  "Play video": "Video abspielen",
  "Playback speed {{ rate }}x": "Wiedergabegeschwindigkeit {{ rate }}x",
  "Poll": "Umfrage",
  "Poll comments": "Umfragekommentare",
  "Poll ended": "Umfrage beendet",
  "Poll options": "Umfrageoptionen",
  "Poll results": "Umfrageergebnisse",
  "Previous image": "Vorheriges Bild",
  "Question": "Frage",
  "Question {{ optionOrderNumber}}": "Frage {{ optionOrderNumber}}",
  "Question is required": "Frage ist erforderlich",
  "Quote Reply": "Zitat-Antwort",
  "Reached the vote limit. Remove an existing vote first.": "Das Abstimmungslimit wurde erreicht. Entfernen Sie zuerst eine bestehende Stimme.",
  "Recording format is not supported and cannot be reproduced": "Aufnahmeformat wird nicht unterstützt und kann nicht wiedergegeben werden",
  "Remind me": "Erinnern",
  "Remind Me": "Erinnern",
  "Reminder set": "Erinnerung gesetzt",
  "Remove reminder": "Erinnerung entfernen",
  "Remove save for later": "„Später ansehen“ entfernen",
  "Replied to a thread": "In einem Thread geantwortet",
  "Reply": "Antworten",
  "Reply to {{ authorName }}": "Antwort an {{ authorName }}",
  "Reply to a message to start a thread": "Antworte auf eine Nachricht, um einen Thread zu starten",
  "Reply to Message": "Auf Nachricht antworten",
  "replyCount_one": "1 Antwort",
  "replyCount_other": "{{ count }} Antworten",
  "Resend": "Erneut senden",
  "Retry upload": "Upload erneut versuchen",
  "Review all options available in this poll": "Überprüfe alle verfügbaren Optionen in dieser Umfrage",
  "Review comments submitted with poll answers": "Überprüfe Kommentare, die mit Umfrageantworten eingereicht wurden",
  "Review poll results and open an option to see detailed votes": "Überprüfe die Umfrageergebnisse und öffne eine Option, um detaillierte Stimmen zu sehen",
  "Review this message and choose whether to delete it, edit it, or send it anyway": "Überprüfe diese Nachricht und wähle, ob du sie löschen, bearbeiten oder trotzdem senden möchtest",
  "Review who voted for this option": "Überprüfe, wer für diese Option gestimmt hat",
  "Save for later": "Für später speichern",
  "Saved for later": "Für später gespeichert",
  "Search": "Suche",
  "Search GIFs": "Search GIFs",
  "search-results-header-filter-source-button-label--channels": "Kanäle",
  "search-results-header-filter-source-button-label--messages": "Nachrichten",
  "search-results-header-filter-source-button-label--users": "Benutzer",
  "Searching for {{ searchSourceType }}...": "Suche nach {{ searchSourceType }}...",
  "Searching...": "Suchen...",
  "searchResultsCount_one": "1 Ergebnis",
  "searchResultsCount_other": "{{ count }} Ergebnisse",
  "Select a thread to continue the conversation": "Wähle einen Thread aus, um die Unterhaltung fortzusetzen",
  "Select more than one option": "Mehr als eine Option auswählen",
  "Select one": "Eine auswählen",
  "Select one or more": "Eine oder mehrere auswählen",
  "Select up to {{count}}_one": "Bis zu {{count}} auswählen",
  "Select up to {{count}}_other": "Bis zu {{count}} auswählen",
  "Select your current location and optionally enable live location sharing": "Wähle deinen aktuellen Standort und aktiviere optional das Teilen des Live-Standorts",
  "Send": "Senden",
  "Send a message": "Nachricht senden",
  "Send a message to start the conversation": "Senden Sie eine Nachricht, um die Unterhaltung zu beginnen",
  "Send Anyway": "Trotzdem senden",
  "Send message request failed": "Senden der Nachrichtenanfrage fehlgeschlagen",
  "Send poll": "Umfrage senden",
  "Sending...": "Senden...",
  "Sent": "Gesendet",
  "Share": "Teilen",
  "Share live location for": "Live-Standort teilen für",
  "Share Location": "Standort teilen",
  "Shared live location": "Geteilter Live-Standort",
  "Shared location": "Geteilter Standort",
  "Shuffle": "Mischen",
  "size limit": "Größenbeschränkung",
  "Slow Mode ON": "Langsamer Modus EIN",
  "Slow mode, wait {{ seconds }}s...": "Langsamer Modus, warte {{ seconds }}s...",
  "Some of the files will not be accepted": "Einige der Dateien werden nicht akzeptiert",
  "Start typing to search": "Tippen Sie, um zu suchen",
  "Stop sharing": "Teilen beenden",
  "Submit": "Absenden",
  "Suggest a new option to add to this poll": "Schlage eine neue Option vor, die zu dieser Umfrage hinzugefügt werden soll",
  "Suggest an option": "Eine Option vorschlagen",
  "Tap to remove": "Tippen zum Entfernen",
  "Tap to remove: {{ reactionName }}": "Tippen zum Entfernen: {{ reactionName }}",
  "Thinking...": "Denken...",
  "this content could not be displayed": "Dieser Inhalt konnte nicht angezeigt werden",
  "This field cannot be empty or contain only spaces": "Dieses Feld darf nicht leer sein oder nur Leerzeichen enthalten",
  "This message did not meet our content guidelines": "Diese Nachricht entsprach nicht unseren Inhaltsrichtlinien",
  "Thread": "Thread",
  "Thread has not been found": "Thread wurde nicht gefunden",
  "Thread reply": "Thread-Antwort",
  "Thread Reply": "Thread-Antwort",
  "ThreadListUnseenThreadsBanner/loading": "Laden...",
  "ThreadListUnseenThreadsBanner/unreadThreads_one": "{{ count }} ungelesener Thread",
  "ThreadListUnseenThreadsBanner/unreadThreads_other": "{{ count }} ungelesene Threads",
  "Threads": "Diskussionen",
  "timestamp/ChannelPreviewTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[Gestern]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/DateSeparator": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Heute]\", \"nextDay\": \"[Morgen]\", \"lastDay\": \"[Gestern]\", \"nextWeek\": \"dddd\", \"lastWeek\": \"[Letzte] dddd\", \"sameElse\": \"ddd, D MMM\" }) }}",
  "timestamp/LiveLocation": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/MessageTimestamp": "{{ timestamp | timestampFormatter(calendar: false; format: HH:mm) }}",
  "timestamp/PollVote": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/PollVoteTooltip": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/relativeDaysAgo": "{{ count }}d ago",
  "timestamp/relativeToday": "Heute",
  "timestamp/relativeWeeksAgo": "{{ count }}w ago",
  "timestamp/relativeYesterday": "Gestern",
  "timestamp/ReminderNotification": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Today] [at] HH:mm\", \"nextDay\": \"[Tomorrow] [at] HH:mm\", \"lastDay\": \"[Yesterday] [at] HH:mm\", \"nextWeek\": \"dddd [at] HH:mm\", \"lastWeek\": \"[Last] dddd [at] HH:mm\", \"sameElse\": \"ddd, D MMM [at] HH:mm\" }) }}",
  "timestamp/SystemMessage": "{{ timestamp | timestampFormatter(format: dddd L) }}",
  "To start recording, allow the camera access in your browser": "Um mit der Aufnahme zu beginnen, erlauben Sie den Zugriff auf die Kamera in Ihrem Browser",
  "To start recording, allow the microphone access in your browser": "Um mit der Aufnahme zu beginnen, erlauben Sie den Zugriff auf das Mikrofon in Ihrem Browser",
  "totalVoteCount_one": "1 Stimme insgesamt",
  "totalVoteCount_other": "{{ count }} Stimmen insgesamt",
  "Translated": "Übersetzt",
  "Translated from {{ language }}": "Übersetzung aus {{ language }}",
  "translationBuilderTopic/notification": "{{value, notification}}",
  "Type a number from 2 to 10": "Geben Sie eine Zahl von 2 bis 10 ein",
  "Unarchive": "Archivierung aufheben",
  "unban-command-args": "[@Benutzername]",
  "unban-command-description": "Einen Benutzer entbannen",
  "Unblock User": "Benutzer entsperren",
  "unknown error": "Unbekannter Fehler",
  "Unmute": "Stummschaltung aufheben",
  "unmute-command-args": "[@Benutzername]",
  "unmute-command-description": "Stummschaltung eines Benutzers aufheben",
  "Unpin": "Anheftung aufheben",
  "Unread messages": "Ungelesene Nachrichten",
  "Unsupported attachment": "Nicht unterstützter Anhang",
  "unsupported file type": "Nicht unterstützter Dateityp",
  "Update": "Aktualisieren",
  "Update the comment attached to your poll answer": "Aktualisiere den Kommentar, der an deine Umfrageantwort angehängt ist",
  "Update your comment": "Ihren Kommentar aktualisieren",
  "Upload blocked": "Upload blockiert",
  "Upload error": "Upload-Fehler",
  "Upload failed": "Upload fehlgeschlagen",
  "Upload type: \"{{ type }}\" is not allowed": "Upload-Typ: \"{{ type }}\" ist nicht erlaubt",
  "User blocked": "Benutzer blockiert",
  "User unblocked": "Blockierung des Benutzers aufgehoben",
  "User uploaded content": "Vom Benutzer hochgeladener Inhalt",
  "Video": "Video",
  "videoCount_one": "Video",
  "videoCount_other": "{{ count }} videos",
  "View": "Ansehen",
  "View {{count}} comments_one": "{{count}} Kommentar anzeigen",
  "View {{count}} comments_other": "{{count}} Kommentare anzeigen",
  "View all": "Alle anzeigen",
  "View original": "Original anzeigen",
  "View results": "Ergebnisse anzeigen",
  "View translation": "Übersetzung anzeigen",
  "Voice message": "Sprachnachricht",
  "Voice message {{ duration }}": "Sprachnachricht {{ duration }}",
  "Voice message deleted": "Sprachnachricht gelöscht",
  "voiceMessageCount_one": "Sprachnachricht",
  "voiceMessageCount_other": "{{ count }} sprachnachrichten",
  "Vote ended": "Abstimmung beendet",
  "Votes": "Stimmen",
  "Wait until all attachments have uploaded": "Bitte warten, bis alle Anhänge hochgeladen wurden",
  "Waiting for network…": "Warte auf Netzwerk…",
  "You": "Du",
  "You've reached the maximum number of files": "Die maximale Anzahl an Dateien ist erreicht"
}
